import { render, staticRenderFns } from "./bulma_rows.vue?vue&type=template&id=6f4a4e8c&scoped=true&lang=html"
import script from "./bulma_rows.vue?vue&type=script&lang=js"
export * from "./bulma_rows.vue?vue&type=script&lang=js"
import style0 from "./bulma_rows.vue?vue&type=style&index=0&id=6f4a4e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4a4e8c",
  null
  
)

export default component.exports